import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Table } from '..';
import Pagination from '../atoms/pagination';
import { DISTRIBUTORS_HEADERS } from '../../constants/table-headers';
import useDeleteDistributor from '../../hooks/distributors/useDeleteDistributor';
import useGetDistributors from '../../hooks/distributors/useGetDistributors';
import useGetMappingData from '../../hooks/mapping/useGetMappingData';
import ActivityIndicator from '../ActivityIndicator';
import DeleteModal from '../Modal/ModalDelete';
import BoxWrapper from '../atoms/boxWrapper';

const TableCompanies: React.FC = () => {
  const history = useHistory();
  const [modalFlag, setModalFlag] = useState<boolean>(false);
  const [id, setId] = useState<string>('');
  const { execute, loading } = useGetDistributors();
  const { execute: executeDelete, loading: loadingDelete } =
    useDeleteDistributor();
  const { execute: executeGetMapping } = useGetMappingData();
  const [distributors, setDistributors] = useState<any>({
    rows: [],
    totalRecords: 0,
    page: 1,
  });
  const [currentPage, setCurrentPage] = useState(1);

  const deleteEnterprise = async (id: string) => {
    executeDelete(id, () => {
      execute(currentPage);
    });
    setModalFlag(false);
  };

  useEffect(() => {
    const loadDistributors = async () => {
      const result = await execute(currentPage);
      setDistributors(result);
    };
    loadDistributors();
  }, [currentPage]);

  const onNavigationClick = (path: string) => {
    history.push(path);
  };

  const navigateMapping = async (id: string) => {
    await executeGetMapping(id);
    onNavigationClick(`/home/companies/mapping/${id}`);
  };

  if (loading || loadingDelete) {
    return <ActivityIndicator />;
  }

  return (
    <BoxWrapper>
      <DeleteModal
        onHide={() => setModalFlag(false)}
        show={modalFlag}
        onConfirmClick={() => deleteEnterprise(id)}
        message="Dados relacionados com a distribuidora podem ser excluidos também"
      />

      <Table
        columns={DISTRIBUTORS_HEADERS}
        data={distributors.rows}
        onEditClick={(id: string) =>
          onNavigationClick(`/home/companies/edit/${id}`)
        }
        onDeleteClick={(id: string) => {
          setModalFlag(true);
          setId(id);
        }}
        onRedirectMappingClick={(id: string) => {
          navigateMapping(id);
        }}
      />
      <Pagination
        currentPage={currentPage}
        totalRecords={distributors.totalRecords}
        setCurrentPage={setCurrentPage}
        rowsPerPage={20}
      />
    </BoxWrapper>
  );
};

export default TableCompanies;
